import { authInstance } from "./axios";

export const getAll = async (keyword = '') => {
    let response = null
    if (keyword != '') {
        response = await authInstance.get(`user?keyword=${keyword}`)
    }
    else {
        response = await authInstance.get(`user`)
    }
    return response
};

export const addNew = async (data) => {
    const response = await authInstance.post(`user`, data)
    return response
};

export const update = async (id, data) => {
    const response = await authInstance.put(`user/${id}`, data)
    return response
};

export const profile = async () => {
    const response = await authInstance.get(`profile`)
    return response
};

export const updateProfile = async (data) => {
    const response = await authInstance.post(`profile`, data)
    return response
};

export const deleteFunction = async (id) => {
    const response = await authInstance.delete(`user/${id}`)
    return response
};

export const exportData = async () => {
    const response = await authInstance.get(`export-user`, {
        responseType: "blob",
        headers: {
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
    })
    return response
};

export const getUserLevelHistory = async (id) => {
    const response = await authInstance.get(`history-level-user/${id}`)
    return response
};

export const getClassByUser = async () => {
    const response = await authInstance.get(`class-room-by-user-student`)
    return response
};

